module.exports = __webpack_public_path__ + "static/blue-ridge-labs-b7eb6a35441b44975ed7afb2bb0bae7f.png";